/**
 * ChargeListContainer
 * --
 */
import React from 'react';
import ChargeListPresenter from './ChargeListPresenter';

const ChargeListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ChargeListPresenter />
    </>
  );
};

export default ChargeListContainer;
